import * as React from 'react';
import { ArrowForward, InfoDetails } from '../../../../Icons';
import { NASProductFragment } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';

interface Props {
	product: NASProductFragment;
	onRulesOpen?: () => void;
}

const Options: React.FC<Props> = ({ product, onRulesOpen }) => {
	const { t } = useTranslation('ServiceAggregation');

	const theme = useTheme('CheckoutAdditionalService').EveryPortLounge;

	if (!product.notes?.length && !product.terms[0]?.url) {
		return null;
	}

	return (
		<div onClick={onRulesOpen} className={theme.notice}>
			<div className={theme.notice__icon}>{InfoDetails}</div>

			<div className={theme.notice__notes}>
				{!product.notes.length && product.terms[0]?.url
					? t('Read the rules of service')
					: product.notes.slice(0, 3).map((note, key) => <span key={key}>{note}. </span>)}
			</div>

			<div className={theme.notice__link}>
				{t('All conditions')} {ArrowForward}
			</div>
		</div>
	);
};

export default Options;
